import { useSearchParam } from "lib/@hooks/use-search-param"
import { VIEW_DRAFTS } from "./library-views"

/**
 * Whether the currently open task was reached from the Draft Components view.
 *
 * Read straight from the URL so it survives a refresh, browser back/forward and a
 * shared link — the origin is view state like every other library param.
 *
 * Carries no permission check: authorisation for the drafts view itself lives on the
 * DemandGuard wrapping it.
 *
 * @returns {boolean}
 */
export function useCameFromDrafts() {
    const [libraryFrom] = useSearchParam("libraryFrom", "")
    const [selectedTaskId] = useSearchParam("libraryTask", "")

    return Boolean(selectedTaskId) && libraryFrom === VIEW_DRAFTS
}
